// extracted by mini-css-extract-plugin
export default {"particleCanvas":"ParticleNetwork_particleCanvas__BduRi"};